import React from 'react'
import { logoMaven } from '../../assets/images'
import { useGlobalStore } from '../../store'
import { CanWeHelp, TourGuide } from '../../components'

import { FooterThemedRightSection, FooterThemedWrapper, FooterWrapper } from './style'
import { Box, Button, Typography } from '@mui/material'

export const LayoutFooter = ({ isThemed = false }) => {
  const { isTourGuideActive } = useGlobalStore()
  return isThemed ? (
    <FooterThemedWrapper className='footerThemedWrapper'>
      <Button
        href='https://www.mavenmagnet.com/privacy-policy'
        target='_blank'
        rel='noopener noreferrer'
        className='privacy-text'
      >
        Privacy Policy
      </Button>
      <FooterThemedRightSection>
        <Typography className='footer-text'>©</Typography>
        <img src={logoMaven} height='20px' alt='' />
      </FooterThemedRightSection>
    </FooterThemedWrapper>
  ) : (
    <FooterWrapper className='footerWrapper'>
      <div>
        © MavenMagnet |{' '}
        <a
          href='https://www.mavenmagnet.com/privacy-policy'
          target='_blank'
          rel='noopener noreferrer'
        >
          Privacy Policy
        </a>{' '}
        | <CanWeHelp />
      </div>
      <img src={logoMaven} height='22px' alt='' />
      {isTourGuideActive && <TourGuide type='reportFooter' />}
    </FooterWrapper>
  )
}
